import * as yup from 'yup';

const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
const dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
const urlRegex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]:\d{2,5}$/;

yup.addMethod(yup.string, 'destinationDefault', function () {
  return this.test('destinationDefault', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && field.value.trim()) {
        resolve(true);
      } else {
        reject(
          createError({
            path,
            message: `${path} is a required field`,
            type: 'required'
          })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'hour', function (fieldClass) {
  return this.test('hour', function () {
    const { createError } = this;
    const fields = document.getElementsByClassName(fieldClass);
    const promises = [];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { value, id } = field;
      const promise = new Promise((resolve, reject) => {
        if (field && hourRegex.test(value)) {
          resolve(true);
        } else {
          reject(createError({ message: 'Invalid hour', path: id }));
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'date', function (fieldClass) {
  return this.test('date', function () {
    const { createError } = this;
    const fields = document.getElementsByClassName(fieldClass);
    const promises = [];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { value, id } = field;
      const promise = new Promise((resolve, reject) => {
        if (field && dateRegex.test(value)) {
          resolve(true);
        } else {
          reject(createError({ message: 'Invalid date', path: id }));
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'day', function (typeField) {
  return this.test('day', function () {
    const { createError } = this;
    const fieldsDayStart = document.getElementsByClassName(
      `input-day-start-${typeField}`
    );
    const fieldsDayEnd = document.getElementsByClassName(
      `input-day-end-${typeField}`
    );
    const fieldsHourStart = document.getElementsByClassName(
      `input-hour-start-${typeField}`
    );
    const fieldsHourEnd = document.getElementsByClassName(
      `input-hour-end-${typeField}`
    );
    const promises = [];
    for (let i = 0; i < fieldsDayStart.length; i++) {
      const dayStartValue = parseInt(fieldsDayStart[i].value, 10);
      const dayEndValue = parseInt(fieldsDayEnd[i].value, 10);
      const hourStartValue = parseInt(
        fieldsHourStart[i].value.replace(/:|_/g, ''),
        10
      );
      const hourEndValue = parseInt(
        fieldsHourEnd[i].value.replace(/:|_/g, ''),
        10
      );
      const { id } = fieldsDayEnd[i];
      const promise = new Promise((resolve, reject) => {
        const validFields = [
          fieldsDayStart[i].value,
          fieldsDayEnd[i].value,
          fieldsHourStart[i].value,
          fieldsHourEnd[i].value
        ].every(field => field);
        if (validFields) {
          if (
            dayStartValue < dayEndValue ||
            (dayStartValue === dayEndValue && hourStartValue < hourEndValue)
          ) {
            resolve(true);
          } else {
            reject(createError({ message: 'Invalid day', path: id }));
          }
        } else {
          resolve(true);
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'month', function (typeField) {
  return this.test('month', function () {
    const { createError } = this;
    const fieldsDateStart = document.getElementsByClassName(
      `input-date-start-${typeField}`
    );
    const fieldsDateEnd = document.getElementsByClassName(
      `input-date-end-${typeField}`
    );
    const fieldsHourStart = document.getElementsByClassName(
      `input-hour-start-${typeField}`
    );
    const fieldsHourEnd = document.getElementsByClassName(
      `input-hour-end-${typeField}`
    );
    const promises = [];
    for (let i = 0; i < fieldsDateStart.length; i++) {
      const { id } = fieldsDateEnd[i];
      const promise = new Promise((resolve, reject) => {
        const validFields = [
          fieldsDateStart[i].value,
          fieldsDateEnd[i].value,
          fieldsHourStart[i].value,
          fieldsHourEnd[i].value
        ].every(field => field);
        if (validFields) {
          const dS = fieldsDateStart[i].value
            .split('/')
            .map(n => parseInt(n, 10));
          const dE = fieldsDateEnd[i].value
            .split('/')
            .map(n => parseInt(n, 10));
          const hS = fieldsHourStart[i].value
            .split(':')
            .map(n => parseInt(n, 10));
          const hE = fieldsHourEnd[i].value
            .split(':')
            .map(n => parseInt(n, 10));
          const dateStart = new Date(
            dS[2],
            dS[1] - 1,
            dS[0],
            hS[0],
            hS[1],
            0,
            0
          );
          const dateEnd = new Date(dE[2], dE[1] - 1, dE[0], hE[0], hE[1], 0, 0);
          if (dateStart < dateEnd) {
            resolve(true);
          } else {
            reject(createError({ message: 'Invalid month', path: id }));
          }
        } else {
          resolve(true);
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'destination', function (typeField) {
  return this.test('destination', function () {
    const { createError } = this;
    const fields = document.getElementsByClassName(
      `input-destination-${typeField}`
    );
    const promises = [];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { value, id } = field;
      const promise = new Promise((resolve, reject) => {
        if (field && value.trim()) {
          resolve(true);
        } else {
          reject(
            createError({
              message: 'Invalid destination',
              path: id,
              type: 'required'
            })
          );
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'identificationValue', function () {
  return this.test('identificationValue', function () {
    const { createError } = this;
    const fields = document.getElementsByClassName(
      'input-identification-value'
    );
    const promises = [];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { value, id } = field;
      const promise = new Promise((resolve, reject) => {
        if (field && value.trim()) {
          resolve(true);
        } else {
          reject(
            createError({
              message: 'Invalid identification value',
              path: id,
              type: 'required'
            })
          );
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'url', function () {
  return this.test('url', function () {
    const { createError } = this;
    const fields = document.getElementsByClassName('input-url');
    const promises = [];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { value, id } = field;
      const promise = new Promise((resolve, reject) => {
        if (urlRegex.test(value)) {
          resolve(true);
        } else {
          reject(
            createError({
              message: 'Invalid url',
              path: id,
              type: 'url'
            })
          );
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

yup.addMethod(yup.string, 'request', function () {
  return this.test('request', function () {
    const { createError } = this;
    const fields = document.getElementsByClassName('config-request');
    const promises = [];
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { value, id } = field;
      const promise = new Promise((resolve, reject) => {
        if (field && value.trim()) {
          resolve(true);
        } else {
          reject(
            createError({
              message: 'Invalid request',
              path: id,
              type: 'request'
            })
          );
        }
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  });
});

const schema = yup.object().shape({
  _id: yup
    .string()
    .required()
    .trim(),
  name: yup
    .string()
    .required()
    .trim(),
  department: yup
    .string()
    .required()
    .trim(),
  description: yup
    .string()
    .required()
    .trim(),
  waitsec: yup
    .number()
    .required()
    .positive()
    .integer()
    .min(0)
    .max(10),
  action: yup
    .string()
    .required()
    .trim(),
  destination: yup.string().destinationDefault(),
  actions: yup
    .string()
    .hour('input-hour')
    .date('input-date')
    .day('action')
    .month('action')
    .destination('action'),
  digits: yup
    .string()
    .hour('input-hour')
    .date('input-date')
    .day('digit')
    .month('digit')
    .destination('digit')
    .identificationValue(),
  url: yup.string().url(),
  configRequest: yup.string().request()
});

export default schema;
